import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

const TabsWrapper = styled.div<TSFixMe>`
  overflow: auto;
  padding: 10px 20px 0;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(153, 153, 189, 0.3);
`

const Tabs = styled.div<TSFixMe>`
  display: flex;
`

const Tab = styled.div<TSFixMe>`
  padding: 10px 5px;
  cursor: pointer;
  margin: 0 20px;
  text-decoration: none;
  color: #5d5c70;
  font-size: 15px;

  &.active {
    padding: 10px 5px 7px 5px;
    font-weight: 500;
    border-bottom: 3px solid #80deea;
  }

  :first-child {
    margin: 0 20px 0 0;
  }

  :last-child {
    margin: 0 0 0 20px;
  }
`

export const ChangesTabs = (props: TSFixMe): TSFixMe => {
  return (
    <TabsWrapper>
      <Tabs>
        <Tab as={NavLink} to="/changes" end>
          <FormattedMessage id="changes.tabs.executed" defaultMessage="Executed" />
        </Tab>

        <Tab as={NavLink} to="/changes/scheduled">
          <FormattedMessage id="changes.tabs.scheduled" defaultMessage="Scheduled" />
        </Tab>
      </Tabs>
    </TabsWrapper>
  )
}
